import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'firstThin'
})
export class FirstThinPipe implements PipeTransform {
	transform(value: string): string {
		let arrStr = value.split(' ');
		let firstWord = arrStr[0];
		let restWords = arrStr.slice(1).join(' ');
		return `<h2><span>${firstWord}</span> ${restWords}</h2>`;
	}
}
